import React from "react";
import { Head } from "../Component/Head";
import Hero from "../assets/img/hero.png";

export default function Home() {
  return (
    <>
      <Head title="Home"></Head>
      <main>
        <section id="hero" class="hero section py-0">
          <div class="container">
            <div class="row gy-4">
              <div
                class="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center"
                data-aos="fade-up"
              >
                <h1>Selamat Datang diAplikasi Peduli TBC</h1>
                <p>
                  Aplikasi ini dibuat untuk memudahkan masyarakat dalam
                  membersamai pengobatan penyakit TBC
                </p>
                <div class="d-flex">
                  <a href="#about" class="btn-get-started">
                    Get Started
                  </a>
                  <a
                    href="https://www.youtube.com/"
                    class="glightbox btn-watch-video d-flex align-items-center"
                  >
                    <i class="bi bi-play-circle"></i>
                    <span>Watch Video</span>
                  </a>
                </div>
              </div>
              <div
                class="col-lg-6 order-1 order-lg-2 hero-img"
                data-aos="zoom-out"
                data-aos-delay="100"
              >
                <img src={Hero} class="img-fluid animated" alt="" />
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
